export default "__VITE_ASSET__DhR0myuD__"